module.exports = __webpack_public_path__ + "media/question4_en.43c553be.mp3";